import * as React from "react";
const SvgSortDownIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 4, viewBox: "0 0 8 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L4 3.99988L8 0H0Z", fill: "#004D48" }));
export default SvgSortDownIcon;
